/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Col } from "reactstrap";
import Chart from "react-apexcharts";
import _ from "lodash";

const DonutChart = (props) => {

  const chartData = {
    series: props.series,
    options: {
      labels: props.legends,
      colors: ["#0FB41C", "#FEBE10", "#6941C6","#ED156E"],
      chart: { type: "donut" },
      legend: { show: false },
      dataLabels: { enabled: false },
      tooltip: { enabled: false },
      fill: { colors: ["#0FB41C", "#FEBE10", "#6941C6","#ED156E"] },
      dropShadow: {
        enabled: true,
        top: 0,
        left: 0,
        blur: 3,
        color: "#000",
        opacity: 0.5
      },
      states: {
        hover: { filter: { type: "lighten", value: 0.5 } },
        active: { filter: { type: "none", value: 0 } }
      },
       responsive: [
      
      {
        breakpoint: 1356,
        options: {
          chart: {
            width: 308,
            height: 308,
          },
        },
      },
    ],
      legend: {
        itemMargin: {
          horizontal: 1,
        },
        position: "right",
      },
      stroke: { width: 0 },
      plotOptions: {
        pie: {
          expandOnClick: false,
          donut: {
            size: "35%",
            labels: {
              show: false,
              name: { show: false },
              total: {
                show: false,
                showAlways: false,
               
              }
            }
          }
        }
      }
    },
    // noData: {
    //   text: "No data text",
    //   align: "center",
    //   verticalAlign: "middle",
    // },
  };

  return (
    <Chart
        options={chartData.options}
        series={chartData.series}
        height={323}
        width={323}
        type="donut"
      />
  );
};

export default DonutChart;
